import { KnownProgram } from "src/constants/programs";

/**
 * Configuration object for different journey types used in the journey overlay dialog when you choose your next journey.
 * Provides detailed content information for each journey type.
 * Each journey contains:
 * - lessons: Array of lesson identifiers for the journey curriculum
 * - translationKey: Key used for i18n translation of journey names
 *
 * Supported journeys: nutrition, mindset, and physical activity
 */
const JOURNEY_CONFIG = {
  "nutrition-journey": {
    lessons: [
      "balancePlate",
      "managingPortions",
      "snackingStrategies",
      "eatingAwayFromHome",
      "coachingSession"
    ],
    translationKey: "nutrition"
  },
  "mindset-journey": {
    lessons: [
      "fuelingMotivation",
      "mindfulEating",
      "navigatingHunger",
      "reframingSabotaging",
      "coachingSession"
    ],
    translationKey: "mindset"
  },
  "physical-activity-journey": {
    lessons: [
      "buildingMovement",
      "establishSteadyExercise",
      "progressingExercise",
      "strengthTraining",
      "coachingSession"
    ],
    translationKey: "activity"
  }
} as const;

export const PROGRAM_FIRST_LESSON: Record<string, string> = {
  [KnownProgram.LIFEBALANCE]: "module01_questionnaire01",
  [KnownProgram.EVERYDAY_DIABETES_JOURNEY]:
    "everyday-diabetes01_lesson01_questionnaire"
};

export default JOURNEY_CONFIG;
